export const EXCEPTIONS = {
    NO_LOCATION_SELECTED: "NO_LOCATION_SELECTED",
    REQUEST_EXPIRED: "REQUEST_EXPIRED",
};